export const convertDecimalToDM = (latitude: number, longitude: number) => {
    // Function to convert a single decimal degree value to DM format
    const toDM = (decimalDegree: number, isLatitude: boolean) => {
        const absolute = Math.abs(decimalDegree);
        const degrees = Math.floor(absolute);
        const minutes = (absolute - degrees) * 60;

        let direction;
        if (isLatitude) {
            direction = decimalDegree >= 0 ? 'N' : 'S';
        } else {
            direction = decimalDegree >= 0 ? 'E' : 'W';
        }

        // Pad degrees with leading zero if longitude and less than 100
        let paddedDegrees = String(degrees);
        if (!isLatitude && degrees < 100) {
            // Longitude can be up to 180, so pad if less than 100
            if (degrees < 10) {
                // For single digit degrees
                paddedDegrees = '00' + degrees;
            } else {
                // For double digit degrees
                paddedDegrees = '0' + degrees;
            }
        } else if (isLatitude && degrees < 10) {
            // Latitude can be up to 90, so pad if less than 10
            paddedDegrees = '0' + degrees;
        }

        // Format minutes to two decimal places
        const formattedMinutes = minutes.toFixed(2);

        return `${direction} ${paddedDegrees}° ${formattedMinutes}'`;
    };

    const latDM = toDM(latitude, true);
    const longDM = toDM(longitude, false);

    return `${latDM} ${longDM}`;
};
